import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { Tables } from "@/integrations/supabase/types"

interface SidebarProfileProps {
  profile: Tables<"profiles"> | undefined
}

export function SidebarProfile({ profile }: SidebarProfileProps) {
  return (
    <div className="flex items-center gap-4 px-8 py-6 border-b border-primary/10 bg-primary/5">
      <Avatar className="h-12 w-12 ring-2 ring-primary ring-offset-2">
        <AvatarImage src={profile?.avatar_url || "/placeholder.svg"} />
        <AvatarFallback className="bg-primary text-white font-medium">
          {profile?.first_name?.[0]}
          {profile?.last_name?.[0]}
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col">
        <span className="text-base font-semibold text-gray-900">
          {profile?.first_name} {profile?.last_name}
        </span>
        <span className="text-sm text-primary font-medium">Online</span>
      </div>
    </div>
  )
}